module.exports = __webpack_public_path__ + "static/sysdone-ani-icon-93fc2953ac6249dd00d8d3b4fb057657.gif";